import React from 'react'
import './MobileComponent.scss'
import { useTranslation } from 'react-i18next'
import RefinedCategories from '../DeviceCategories/RefinedCategories'
import CustomSortBy from '../MobileSort/CustomSortBy'
import MobileFilter from '../MobileFilter/MobileFilter'
import CustomInfiniteHits2 from '../InfiniteHits/InfiniteHits'
import CustomStats from '../Stats/Stats'

const MobileComponent = (currentRefinement: any) => {
  const { t } = useTranslation()
  const win = window

  return (
    <div className="mobileComponent">
      <div className="mobileDeviceTitle">{t('devices')}</div>
      <div className="mobileCategories">
        <RefinedCategories attribute="type" facetOrdering={true} />
      </div>
      <div className="mobileSortAndFilter">
        <div className="mobileStats">
          {currentRefinement !== '' ? (
            <>
              <CustomStats
                lang={win.document.documentElement.lang}
                query={currentRefinement}
              />
            </>
          ) : null}
        </div>
        <div className="sortAndFilter">
          <CustomSortBy />
          <MobileFilter />
        </div>
      </div>
      <div className="devices_list">
        {currentRefinement !== '' ? (
          <>
            <CustomInfiniteHits2 />
          </>
        ) : null}
      </div>
    </div>
  )
}

export default MobileComponent
